import React from 'react'
import EAButton from '../shared/Buttons/EAButton';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../../features/Loading/LoadingSpinner';

interface IProps {
    loader: boolean;
    paymentUrl: string;
    hasSubmitted: boolean;
}

const SubmitButton: React.FC<IProps> = ({ loader, paymentUrl, hasSubmitted }) => {
    const { t } = useTranslation();
  return (
    <>
    {!loader ? (
                <>
                  {paymentUrl === "" ? (
                    <>
                      {!hasSubmitted ? (
                        <EAButton title={t("kupuje_z_obowiazkiem_zaplaty")} inputType="submit" fullWidth />
                      ) : (
                        <LoadingSpinner />
                      )}
                    </>
                  ) : (
                    <>
                      <EAButton
                        title={t("przejdz_do_platnosci")}
                        fullWidth
                        onClick={() => window.open(paymentUrl, "_blank", "noreferrer")}
                      />
                       <span className="small-akapit">
                    {t("za_chwile_zostaniesz_automatycznie_przeniesiony_do_systemu_platnosci")}
                  </span>
                    </>
                  )}
                </>
              ) : (
                <LoadingSpinner />
              )}
              </>
  )
}

export default SubmitButton